<div class="priority-rule">
  <div class="pra">
    {{ "automation.message_rule.priority.title" | translate }}
    <!-- 系统先根据以下原则计算每个规则的分数： -->
  </div>
  <div class="pra">
    <ul>
      <li>
        {{ "automation.message_rule.priority.rule_1" | translate }}
        <!-- 1. 设置了时段：+1分 -->
      </li>
      <li>
        {{ "automation.message_rule.priority.rule_2" | translate }}
        <!-- 2. 每命中一个关键词：+1分 -->
      </li>
      <li>
        {{ "automation.message_rule.priority.rule_3" | translate }}
        <!-- 3. 阶段没有全部选中：+1分 -->
      </li>
      <li>
        {{ "automation.message_rule.priority.rule_4" | translate }}
        <!-- 4. 房间没有选择不限：+1分 -->
      </li>
      <li>
        {{ "automation.message_rule.priority.rule_5" | translate }}
        <!-- 5. 渠道账号没有选择不限：+1分 -->
      </li>
      <li>
        {{ "automation.message_rule.priority.rule_6" | translate }}
        <!-- 6. 渠道没有选择不限：+1分 -->
      </li>
      <li>
        {{ "automation.message_rule.priority.rule_7" | translate }}
        <!-- 7. 匹配模式选择包含全部关键词：+10分 -->
      </li>
    </ul>
  </div>
  <div class="pra">
    {{ "automation.message_rule.priority.tip" | translate }}
    <!-- 在满足条件的规则多于1个时，仅触发得分最高的规则，如果有并列得分，则随机选择其中之一触发。 -->
  </div>
  <div class="footer">
    <button nz-button nzType="primary" (click)="onClose()">
      {{ "automation.message_rule.priority.got_btn" | translate }}
      <!-- 知道了 -->
    </button>
  </div>
</div>
